import { Box, Typography } from '@mui/material'
import React from 'react'

const EmptyState = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', mt: 10 }}>
      <img src="/case-tracking.svg" alt="" style={{ width: 300 }} />
      <Typography variant="h6" sx={{ mt: 5, textAlign: 'center' }}>
        Start tracking your cases by adding a new one!
      </Typography>
    </Box>
  )
}

export default EmptyState